import { render, staticRenderFns } from "./publicityRecords.vue?vue&type=template&id=612aa736"
import script from "./publicityRecords.vue?vue&type=script&lang=js"
export * from "./publicityRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports